import { TextField } from "@mui/material";
import { useState } from "react";
import { getIdFromResponse } from "./GetNfcDialog";
import ReadNfcButton from "./ReadNfcButton";
import { isBlank } from "./StringUtils";
import { hasNfc } from "./Utils";

export interface DeviceIdFieldProps {
	productInternalReference: string;
	deviceId: string | undefined;
	onChange: (deviceId: string) => void;
	onError(error: Error): void;
	onNfcStart?(): void;
	onNfcFinish?(): void;
	nfcBusy?: boolean;
}

function DeviceIdField(props: DeviceIdFieldProps) {
	const {
		deviceId,
		productInternalReference,
		onNfcStart,
		onNfcFinish,
		nfcBusy,
	} = props;
	const [error, setError] = useState<Error>();

	return (
		<TextField
			data-cy="finished-product-device-id"
			fullWidth
			label="Device ID"
			size="small"
			error={error !== undefined}
			helperText={error?.message}
			disabled={true}
			value={isBlank(deviceId) ? "" : deviceId}
			placeholder="Device ID"
			InputProps={{
				id: "finished-product-device-id",
				endAdornment: hasNfc(productInternalReference) ? (
					<ReadNfcButton
						onStart={onNfcStart}
						onFinish={onNfcFinish}
						disabled={nfcBusy}
						onError={async (error) => {
							console.error("Failed to read NFC");
							console.error(error);
							setError(error);
							props.onError(error);
						}}
						onNfc={(nfc) => {
							if (nfc !== undefined) {
								const deviceId = getIdFromResponse(nfc);
								if (deviceId !== undefined) {
									props.onChange(deviceId);
								} else {
									console.error("Unable to parse NFC", JSON.stringify(nfc));
								}
							}
						}}
					/>
				) : null,
			}}
		/>
	);
}

export default DeviceIdField;
